import { Select, SelectOnChange } from "@wise-emotions/react-select";
import { useFormContext } from "react-hook-form";
import React, { Ref } from "react";

export interface AreaCodeSelectProps {
  name: string;
  label: string;
}

const AreaCodeSelect = React.forwardRef(
  (props: AreaCodeSelectProps, ref: Ref<HTMLSelectElement>) => {
    const { name, label, ...rest } = props;

    const { register, setValue } = useFormContext();
    const selectOnChange = register(name);
    const onChange: SelectOnChange = (e, value) => {
      setValue(name, value);
    };
    return (
      <Select
        options={[
          {
            label: "+39",
            value: "+39",
          },
          {
            label: "+33",
            value: "+33",
          },
          {
            label: "+49",
            value: "+49",
          },
          {
            label: "+44",
            value: "+44",
          },
          {
            label: "+1",
            value: "+1",
          },
        ]}
        id="phone-number-prefix"
        label={label}
        {...register(name, { required: true })}
        onChange={(e, value) => {
          onChange(e, value);
          if (selectOnChange?.onChange) {
            selectOnChange.onChange(e);
          }
        }}
      />
    );
  },
);

export default AreaCodeSelect;
